import { updatedtodo } from "../actions";

const updatedTodo = (todoId, text) => {
    console.log(todoId, text);
    return async (dispatch) => {
        const response = await fetch(
            `https://haider-todo.herokuapp.com/todos/${todoId}`,
            {
                method: "PATCH",
                body: JSON.stringify({
                    text: text,
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                },
            }
        );
        const todo = await response.json();
        dispatch(updatedtodo(todo.id, todo.text));
    };
};

export default updatedTodo;
